module.exports = __webpack_public_path__ + "static/media/balls.286bdd99.svg";